import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Form, Loader, InputOnChangeData } from 'semantic-ui-react'
import { Button } from '@apex/component-library'
import { useFormatMessage } from '../../utils/intlHelpers'
import { ALL_REQUESTED_PERMISSIONS } from '../../constants/permissions'
import { legit } from 'apex-legit-service'
import { LEGIT_SERVICE_CONFIG } from '../../constants/okta'
import { Dispatch } from 'redux'
import { isPrimitiveEmpty } from '../../utils/transferFormValidation'
import { setRumUser } from '../..//utils/datadog'

export interface ApexLegacyLoginProps {
  defaultUsername: string
  loggingIn: boolean
  legacyLoginSubmit: (params: { username: string; password: string }) => void
}
export const ApexLegacyLoginComponent = ({ defaultUsername, loggingIn, legacyLoginSubmit }: ApexLegacyLoginProps) => {
  const formatMessage = useFormatMessage()
  const [username, setUsername] = useState(defaultUsername)
  const [password, setPassword] = useState('')
  const [usernameError, setUsernameError] = useState<boolean>(false)
  const [passwordError, setPasswordError] = useState<boolean>(false)

  const handleLegacyLogin = (event: React.SyntheticEvent) => {
    setUsernameError(isPrimitiveEmpty(username))
    setPasswordError(isPrimitiveEmpty(password))

    if (!isPrimitiveEmpty(username) && !isPrimitiveEmpty(password)) {
      setRumUser({ loginType: 'legacy' })
      legacyLoginSubmit({ username: username, password: password })
    }
  }

  const onUsernameChange = (value: string) => {
    setUsernameError(isPrimitiveEmpty(value))
    setUsername(value)
  }

  const onPasswordChange = (value: string) => {
    setPasswordError(isPrimitiveEmpty(value))
    setPassword(value)
  }

  return (
    <>
      <Form onSubmit={handleLegacyLogin} error={true}>
        <Loader active={loggingIn} />
        <Form.Input
          className={'test-id-legacy-username'}
          value={username}
          label={formatMessage('login.username')}
          onChange={(e: React.SyntheticEvent, data: InputOnChangeData) => onUsernameChange(data.value)}
          required={true}
          error={
            usernameError && {
              content: formatMessage('login.username.required')
            }
          }
        />
        <Form.Input
          className={'test-id-legacy-password'}
          label={formatMessage('login.password')}
          value={password}
          onChange={(e: React.SyntheticEvent, data: InputOnChangeData) => onPasswordChange(data.value)}
          type='password'
          required={true}
          error={
            passwordError && {
              content: formatMessage('login.password.required')
            }
          }
        />
        <Button type='submit' disabled={loggingIn} variant='primary' width='100%'>
          {formatMessage('login.signin')}
        </Button>
      </Form>
    </>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  legacyLoginSubmit: (params: { username: string; password: string }) => {
    dispatch(
      legit.login(LEGIT_SERVICE_CONFIG, {
        apexUser: true,
        ...params,
        permissions: ALL_REQUESTED_PERMISSIONS
      })
    )
  }
})

export const ApexLegacyLogin = connect(undefined, mapDispatchToProps)(ApexLegacyLoginComponent)
